import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router";

import { getMiljokontrollBildeBase64 } from "../../../../actions/miljokontrollerActions";
import InteractiveImageViewer from "../../InteractiveImageViewer";
import SpinLoader from "../../SpinLoader";

const spinnerLoaderProps = {
  height: 42,
  width: 42,
  thickness: 3,
  pColor: "#ffffff",
  sColor: "#4d4d4d",
};

const TidskontrollOrginalbilde = () => {
  const { miljokontrollId, observasjonId, bildeId } = useParams();
  const [bilde, setBilde] = useState(undefined);
  const [showSpinner, setShowSpinner] = useState(false);

  const dispatch = useDispatch();

  useEffect(() => {
    setShowSpinner(true);
    dispatch(
      getMiljokontrollBildeBase64(miljokontrollId, observasjonId, bildeId),
    )
      .then((result) => {
        setShowSpinner(false);
        setBilde(result);
      })
      .catch(() => setShowSpinner(false));
  }, [dispatch, miljokontrollId, observasjonId, bildeId]);

  if (showSpinner) {
    return (
      <div style={{ margin: "auto", paddingTop: 50, width: 0 }}>
        <SpinLoader {...spinnerLoaderProps} />
      </div>
    );
  }

  if (!bilde?.src) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
          fontSize: "18px",
          color: "#666",
        }}
      >
        Image not found
      </div>
    );
  }

  return (
    <InteractiveImageViewer
      imageSrc={bilde.src}
      imageAlt="Tidskontroll - orginalbilde"
      showControls={true}
      backgroundColor="transparent"
    />
  );
};

export default TidskontrollOrginalbilde;
